<template>
  <div class="declaration tw-flex tw-flex-col tw-items-center tw-mt-8">
    <br />
    <br />
    <!-- Card Container -->
    <div class="tw-w-full tw-max-w-4xl tw-px-4">
      <h2 style="color: #114cac" class="tw-text-2xl tw-font-semibold tw-mb-4">
        Insured Details
      </h2>
      <hr class="tw-border-gray-300 tw-my-4" />

      <!-- Client Type Selection -->
      <span class="tw-text-gray-700 tw-font-medium tw-mb-2"
        >Select type of client</span
      >
      <v-card-actions
        class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-gap-4 tw-mb-6"
      >
        <v-btn
          @click="setClientType('Individual')"
          class="tw-border tw-rounded-md tw-py-2 tw-px-4 tw-font-semibold tw-cursor-pointer tw-text-center tw-w-full md:tw-w-48"
          :style="
            clientType === 'Individual'
              ? 'background-color: #DBEAFE; color: #1E40AF; border-color: #1E40AF;'
              : 'background-color: white; color: #1E40AF; border-color: #1E40AF;'
          "
        >
          <span class="mdi mdi-briefcase tw-mr-2"></span> Individual Client
        </v-btn>
        <v-btn
          @click="setClientType('Corporate')"
          class="tw-border tw-rounded-md tw-py-2 tw-px-4 tw-font-semibold tw-cursor-pointer tw-text-center tw-w-full md:tw-w-48"
          :style="
            clientType === 'Corporate'
              ? 'background-color: #DBEAFE; color: #1E40AF; border-color: #1E40AF;'
              : 'background-color: white; color: #1E40AF; border-color: #1E40AF;'
          "
        >
          <span class="mdi mdi-domain tw-mr-2"></span> Corporate Client
        </v-btn>
      </v-card-actions>

      <!-- Form for Individual or Corporate Client -->
      <v-form v-model="isFormValid" ref="form">
        <div
          v-if="clientType === 'Individual'"
          class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 tw-mb-6"
        >
          <v-select
            v-model="form.title"
            :items="titles"
            label="Title"
            class="tw-w-20"
            :rules="[required('Title')]"
            placeholder="Mr."
          />

          <v-text-field
            v-model="form.fullName"
            label="Full Name"
            class="tw-w-full"
            :rules="[required('Full Name')]"
            placeholder="John Doe"
          ></v-text-field>

          <v-text-field
            v-model="form.dateOfBirth"
            label="Date of Birth"
            type="date"
            class="tw-w-full"
            :rules="[required('Date of Birth'), validateAge]"
            :max="maxDate"
          ></v-text-field>

          <v-select
            v-model="form.gender"
            :items="['Male', 'Female']"
            label="Gender"
            class="tw-w-full"
            :rules="[required('Gender')]"
          ></v-select>

          <v-text-field
            v-model="form.mobileNumber"
            label="Mobile No"
            class="tw-w-full phone-input border"
            placeholder="Enter mobile number"
            :rules="[required('Mobile Number'), validatePhoneNumber]"
          />

          <v-text-field
            v-model="form.email"
            label="Email ID"
            type="email"
            class="tw-w-full"
            :rules="[required('Email'), emailFormat()]"
          ></v-text-field>

          <v-text-field
            v-model="form.idNumber"
            label="ID Number"
            class="tw-w-full"
            :rules="[required('ID Number')]"
            maxlength="8"
            minlegth="6"
          ></v-text-field>

          <v-text-field
            v-model="form.kraPin"
            label="KRA PIN"
            class="tw-w-full"
            :rules="[required('KRA PIN'), kraPinFormat()]"
          ></v-text-field>
        </div>

        <!-- Form for Corporate Client -->
        <div
          v-if="clientType === 'Corporate'"
          class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 tw-mb-6"
        >
          <v-text-field
            v-model="form.companyName"
            label="Company Name"
            class="tw-w-full"
            :rules="[required('Company Name')]"
            @input="toUppercase"
          ></v-text-field>

          <v-text-field
            v-model="form.registrationNumber"
            label="Company Registration No."
            class="tw-w-full"
            :rules="[required('Company Registration No.')]"
            @input="toUppercase"
          ></v-text-field>

          <v-text-field
            v-model="form.dateofRegistration"
            label="Date of Registration"
            type="date"
            class="tw-w-full"
            :rules="[required('Date of Registration')]"
          ></v-text-field>

          <v-text-field
            v-model="form.mobileNumber"
            prefix="+254"
            label="Mobile No"
            class="tw-w-full"
            placeholder="Enter mobile number"
            :rules="[required('Mobile Number'), validatePhoneNumber]"
            @input="handleMobileInput"
          />

          <v-text-field
            v-model="form.email"
            label="Email ID"
            type="email"
            class="tw-w-full"
            :rules="[required('Email'), emailFormat()]"
          ></v-text-field>

          <v-text-field
            v-model="form.kraPin"
            label="KRA PIN"
            class="tw-w-full"
            :rules="[required('KRA PIN'), kraPinFormat()]"
          ></v-text-field>
        </div>

        <!-- Declaration and Checkbox -->
        <h3 class="c-blue-text title-font tw-text-base md:tw-text-lg tw-mt-3 md:tw-mt-10">Declaration & Authorisation to obtain and use information</h3>
        <div class="tw-px-2 tw-py-5 c-gray-text">
            <span>
              I confirm that the information given is correct and accurate. Your policy will be sold to you based on the information you have provided. If the information provided is incorrect or incomplete, your policy could be canceled, or a claim rejected/not paid in full.
            </span>
        </div>
        <div class="tw-px-2 tw-py-5 c-gray-text">
          <v-checkbox
              v-model="form.understoodTerm"
              label="Terms and conditions of this product."
              :rules="[check()]"
          >
            <template #label>
              <terms-and-conditions pre="I also confirm that i’ve read and understood the " post="of this product." />
            </template>
          </v-checkbox>
          <v-checkbox
              v-model="form.authorizeTerm"
              :rules="[check()]"
          >
            <template #label>
              <span>
                I authorize APA Insurance to obtain and use my personal information.
                I also confirm that I’ve read and understood the Apollo Group’s Privacy Policy that can be accessed through this
                <a href="https://www.apainsurance.org/privacy_policy" target="_blank" @click.stop class="link-text" rel="noopener">APA privacy policy</a>.
              </span>
            </template>
          </v-checkbox>
        </div>
        <v-card-actions
          class="tw-flex tw-justify-center col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8"
        >
          <v-btn
            block
            large
            color="primary"
            class="my-3"
            @click="submitForm"
            :disabled="!isFormValid"
          >
            {{ isFormValid ? "Next" : "Check if all fields are filled" }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import validations from '@/utils/validations';
import TermsAndConditions from '@/components/TermsAndConditions';
import { log } from '@/utils/errorLogger';

export default {
  name: 'Declaration',
  components: { TermsAndConditions },
  data() {
    const formPayload = JSON.parse(localStorage.getItem('formPayload')) || {};
    return {
      showDropdown: false,
      isFormValid: false,
      maxDate: this.calculateMaxDate(),
      clientType: 'Individual',
      titles: ['Mr.', 'Ms.', 'Mrs.', 'Miss', 'Dr.', 'Prof.', 'Master'],
      form: {
        title: formPayload.title || '',
        fullName: formPayload.fullname ? `${formPayload.fullname}` : '',
        dateOfBirth: '',
        gender: '',
        mobileNumber: formPayload.mobileNo || '',
        email: formPayload.email || '',
        idNumber: formPayload.idNumber || '',
        kraPin: formPayload.kraPin || '',
        companyName: '',
        registrationNumber: '',
        dateofRegistration: '',
        termsAccepted: false,
        privacyAccepted: false,
      },
    };
  },
  watch: {
    'form.termsAccepted': {
      handler(newValue) {
        if (newValue) {
          this.$refs.form.validate();
        }
      },
    },
    'form.privacyAccepted': {
      handler(newValue) {
        if (newValue) {
          this.$refs.form.validate();
        }
      },
    },
  },
  mounted() {
    const savedFormData = JSON.parse(localStorage.getItem('additionalPersonalDetails')) || {};
    this.form.title = savedFormData.title || '';
    this.form.dateOfBirth = savedFormData.dateOfBirth || '';
    this.form.gender = savedFormData.gender || '';
  },
  methods: {
    calculateMaxDate() {
      const today = new Date();
      today.setFullYear(today.getFullYear() - 18);
      return today.toISOString().split('T')[0];
    },

    toUppercase() {
      this.form.registrationNumber = this.form.registrationNumber.toUpperCase();
      this.form.companyName = this.form.companyName.toUpperCase();
    },

    validateAge(value) {
      const selectedDate = new Date(value);
      const minAllowedDate = new Date(this.maxDate);
      return (
        selectedDate <= minAllowedDate || 'You must be at least 18 years old'
      );
    },
    ...validations,
    handleMobileInput(value) {
      const cleanNumber = value.replace(/\D/g, '');

      if (cleanNumber.startsWith('0')) {
        this.form.mobileNumber = `254${cleanNumber.slice(1)}`;
      } else {
        this.form.mobileNumber = cleanNumber.startsWith('254')
          ? cleanNumber
          : `254${cleanNumber}`;
      }
    },
    validatePhoneNumber(value) {
      return value && value.startsWith('+254') && value.length === 13
        ? true
        : 'Enter a valid 9-digit phone number';
    },
    required(field) {
      return (v) => !!v || `${field} is required`;
    },
    requiredCheckbox(field) {
      return (v) => v || `Please accept the ${field}`;
    },
    emailFormat() {
      return (v) => /^[^@]+@[^.]+\..+$/.test(v) || 'E-mail must be valid';
    },
    setClientType(type) {
      this.clientType = type;
    },
    async submitForm(e) {
      if (!this.isFormValid) return;
      e.preventDefault();

      const formPayload = JSON.parse(localStorage.getItem('formPayload')) || {};
      localStorage.setItem('additionalPersonalDetails', JSON.stringify(this.form));
      const quoteId = localStorage.getItem('quoteId') || null;

      // Build payload
      const payload = {
        agentId: '',
        dob: this.form.dateOfBirth || formPayload.dob,
        email: this.form.email || formPayload.email,
        firstName:
          this.clientType === 'Individual'
            ? this.form.fullName.split(' ')[0] || formPayload.firstName
            : '',
        lastName:
          this.clientType === 'Individual'
            ? this.form.fullName.split(' ').slice(1).join(' ')
              || formPayload.lastName
            : '',
        gender: this.form.gender || formPayload.gender,
        mobileNo: this.form.mobileNumber || formPayload.mobileNo,
        idNumber: this.form.idNumber,
        isCorporate: this.clientType === 'Corporate',
        kra: this.form.kraPin,
        title: this.form.title || formPayload.title,
        customerId: formPayload.customerId,
        quoteId,
        termsAccepted: this.form.termsAccepted,
        privacyAccepted: this.form.privacyAccepted,
      };

      if (this.clientType === 'Corporate') {
        payload.companyName = this.form.companyName;
        payload.registrationNumber = this.form.registrationNumber;
        payload.dateofRegistration = this.form.dateofRegistration;
      }
      // Update formPayload with payload details
      const updatedFormPayload = { ...formPayload, ...payload };
      localStorage.setItem('formPayload', JSON.stringify(updatedFormPayload));

      try {
        const response = await axios.post(
          '/motor/api/quote/updateInformation',
          payload,
        );
        if (response) {
          this.$toast.success('sucess');
        }

        this.$emit('next');
      } catch (error) {
        log(error, this, 'submitForm');
        this.$toast.error('error');
      }
    },
  },
};
</script>

<style scoped>
.declaration {
  top: 10%;
}

.declaration .v-label {
  color: black;
  font-size: 1.1rem;
}
.declaration .v-label .link-text {
  color: blue;
}

.declaration .v-label .link-text:hover {
  text-decoration: underline;
}
</style>
